import LogbookBlock from './LogbookBlock';
import { LogbookBlockProps, LogbookBlockValueProps } from './types';

export type { LogbookBlockProps, LogbookBlockValueProps };
export default LogbookBlock;
